import script from "./PhaserGame.vue?vue&type=script&setup=true&lang=js"
export * from "./PhaserGame.vue?vue&type=script&setup=true&lang=js"

import "./PhaserGame.vue?vue&type=style&index=0&id=2afb7170&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2afb7170"]])

export default __exports__